import * as React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTableToolbar } from '@celebration/design-system/dist/lib/table-toolbar';

export default createComponent({
    react: React,
    elementClass: ClbTableToolbar,
    tagName: ClbTableToolbar.tagName,
    events: ClbTableToolbar.events,
});

export const TableToolbarSlots = ClbTableToolbar.slots;
